import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import { payloadToQueryParamsUrl } from '@/_shared/helpers/payloadToQueryParamsUrl';
import { SkillCategory } from '@/swagger/constants/contents-orchestrator-enums';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_DASHBOARD_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_RECENTS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_ME_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_TAGS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_DETAILS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_START_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_PROGRESS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_END_PATH_KEY,
} from '@/swagger/constants/contents-orchestrator-keys';
import {
  API_GET_CONTENTS_BY_TYPE_REQUEST_QUERY_PARAMS,
  API_GET_DASHBOARD_CONTENTS_REQUEST_QUERY_PARAMS,
  API_GET_MY_CONTENTS_REQUEST_QUERY_PARAMS,
  API_GET_NEW_CONTENTS_REQUEST_QUERY_PARAMS,
} from '../types';

export const API_GET_DASHBOARD_CONTENTS = (
  organizationId: string,
  queryParams: API_GET_DASHBOARD_CONTENTS_REQUEST_QUERY_PARAMS,
) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_DASHBOARD_PATH_KEY, {
    organizationId,
  });
  return payloadToQueryParamsUrl(queryParams, baseUrl);
};

export const API_GET_CONTENTS_BY_TYPE = (
  organizationId: string,
  queryParams: API_GET_CONTENTS_BY_TYPE_REQUEST_QUERY_PARAMS,
) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_PATH_KEY, {
    organizationId,
  });
  return payloadToQueryParamsUrl(queryParams, baseUrl);
};

export const API_GET_NEW_CONTENTS = (
  organizationId: string,
  queryParams: API_GET_NEW_CONTENTS_REQUEST_QUERY_PARAMS,
) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_RECENTS_PATH_KEY, {
    organizationId,
  });
  return payloadToQueryParamsUrl(queryParams, baseUrl);
};

export const API_GET_MY_CONTENTS = (
  organizationId: string,
  queryParams: API_GET_MY_CONTENTS_REQUEST_QUERY_PARAMS,
) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_ME_PATH_KEY, {
    organizationId,
  });
  return payloadToQueryParamsUrl(queryParams, baseUrl);
};

export const API_GET_TAGS_CONTENTS = (organizationId: string, skillCategory?: SkillCategory) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_TAGS_PATH_KEY, {
    organizationId,
  });
  return skillCategory ? payloadToQueryParamsUrl({ skillCategory }, baseUrl) : baseUrl;
};

export const API_GET_CONTENT_DETAILS = (organizationId: string, contentId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_DETAILS_PATH_KEY, {
    organizationId,
    contentId,
  });
};

export const API_GET_CONTENT_START = (organizationId: string, contentId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_START_PATH_KEY, {
    organizationId,
    contentId,
  });
};

export const API_POST_CONTENT_START = (organizationId: string, contentId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_START_PATH_KEY, {
    organizationId,
    contentId,
  });
};

export const API_POST_CONTENT_PROGRESS = (organizationId: string, contentId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_PROGRESS_PATH_KEY, {
    organizationId,
    contentId,
  });
};

export const API_POST_CONTENT_END = (organizationId: string, contentId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_END_PATH_KEY, {
    organizationId,
    contentId,
  });
};
